import React from "react";
import config from "../../config/enviroment";
import { Overlay, Content, LoadingImage, Message } from "./styles";

type Props = {
  open: boolean;
  message: string;
};

const MarcaBlancaOnboardingProgressModal: React.FC<Props> = ({
  open,
  message,
}) => {
  if (!open) return null;

  return (
    <Overlay>
      <Content>
        <LoadingImage
          src={`${config.urlMultimedia}/babilonia/v4/iconos/logo-epayco-load-p-nuevo.gif`}
        />
        <Message>{message}</Message>
      </Content>
    </Overlay>
  );
};

export default MarcaBlancaOnboardingProgressModal;
